// extracted by mini-css-extract-plugin
module.exports = {"layers":"Layers_layers__kAIXF","layer":"Layers_layer__wBVJZ"};